"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useOAuth_exports = {};
__export(useOAuth_exports, {
  useOAuth: () => useOAuth
});
module.exports = __toCommonJS(useOAuth_exports);
var import_clerk_react = require("@clerk/clerk-react");
var AuthSession = __toESM(require("expo-auth-session"));
var WebBrowser = __toESM(require("expo-web-browser"));
var import_errors = require("../utils/errors");
function useOAuth(useOAuthParams) {
  const { strategy } = useOAuthParams || {};
  if (!strategy) {
    return import_errors.errorThrower.throw("Missing oauth strategy");
  }
  const { signIn, setActive, isLoaded: isSignInLoaded } = (0, import_clerk_react.useSignIn)();
  const { signUp, isLoaded: isSignUpLoaded } = (0, import_clerk_react.useSignUp)();
  async function startOAuthFlow(startOAuthFlowParams) {
    if (!isSignInLoaded || !isSignUpLoaded) {
      return {
        createdSessionId: "",
        signIn,
        signUp,
        setActive
      };
    }
    const oauthRedirectUrl = (startOAuthFlowParams == null ? void 0 : startOAuthFlowParams.redirectUrl) || useOAuthParams.redirectUrl || AuthSession.makeRedirectUri({
      path: "oauth-native-callback"
    });
    await signIn.create({ strategy, redirectUrl: oauthRedirectUrl });
    const { externalVerificationRedirectURL } = signIn.firstFactorVerification;
    const authSessionResult = await WebBrowser.openAuthSessionAsync(
      // @ts-ignore
      externalVerificationRedirectURL.toString(),
      oauthRedirectUrl
    );
    const { type, url } = authSessionResult || {};
    if (type !== "success") {
      return {
        authSessionResult,
        createdSessionId: "",
        setActive,
        signIn,
        signUp
      };
    }
    const params = new URL(url).searchParams;
    const rotatingTokenNonce = params.get("rotating_token_nonce") || "";
    await signIn.reload({ rotatingTokenNonce });
    const { status, firstFactorVerification } = signIn;
    let createdSessionId = "";
    if (status === "complete") {
      createdSessionId = signIn.createdSessionId;
    } else if (firstFactorVerification.status === "transferable") {
      await signUp.create({
        transfer: true,
        unsafeMetadata: (startOAuthFlowParams == null ? void 0 : startOAuthFlowParams.unsafeMetadata) || useOAuthParams.unsafeMetadata
      });
      createdSessionId = signUp.createdSessionId || "";
    }
    return {
      authSessionResult,
      createdSessionId,
      setActive,
      signIn,
      signUp
    };
  }
  return {
    startOAuthFlow
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useOAuth
});
//# sourceMappingURL=useOAuth.js.map